"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color,
      canClose = _ref.canClose,
      size = _ref.size;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;box-sizing:border-box;align-items:center;padding:8px 10px 8px 12px;border-radius:", _styleConsts.borderRadius, ";background-color:", color.grey4, ";min-height:", _styleConsts.height.medium, ";font-size:", _styleConsts.font.size.medium, ";color:", color.black1, ";fill:", color.black1, ";&:active{background-color:", color.grey2, ";}&:hover{background-color:", color.grey3, ";}&[disabled]{opacity:.5;cursor:not-allowed;background-color:", color.grey4, ";}& button{width:24px;height:24px;}", canClose ? "\n    padding-right: 6px;\n  " : '', "\n\n  ", size === 'large' ? "\n    min-height: ".concat(_styleConsts.height.large, ";\n    padding: 12px;\n    font-size: ").concat(_styleConsts.font.size.large, ";\n\n    ").concat(canClose ? "\n      padding-right: 10px;\n    " : '', "\n  ") : '')
  );
};

var StyledTag = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-1z0kf7k0"
})(styles));
var _default = StyledTag;
exports.default = _default;